import { render, staticRenderFns } from "./AutoSettings.vue?vue&type=template&id=52df57ab"
import script from "./AutoSettings.vue?vue&type=script&lang=ts"
export * from "./AutoSettings.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports